<template>
  <div class="form-card form-card--bare">
    <div class="form-card__body">
      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-numero">Número</label>
        <input
          id="tpcheck-numero"
          v-model="tp_check.number"
          type="number"
          class="form-control"
          placeholder="N° de cheque"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-emisor">Nombre del emisor</label>
        <input
          id="tpcheck-emisor"
          v-model.trim="tp_check.name"
          type="text"
          class="form-control"
          placeholder="Nombre del emisor"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-cuit">CUIT</label>
        <input
          id="tpcheck-cuit"
          v-model="tp_check.cuit"
          type="number"
          class="form-control"
          placeholder="CUIT"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-banco">Banco</label>
        <sucursales-bancarias
          id="tpcheck-banco"
          v-model="tp_check.bank_name"
        />
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-tipo">Tipo</label>
        <select
          id="tpcheck-tipo"
          v-model="tp_check.check_kind"
          class="form-control"
        >
          <option v-for="opt in checkKindOptions" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </select>
      </div>

      <div class="form-card__field">
        <label class="form-card__label">Cliente</label>
        <typeahead
          :name="'client'"
          :plh="'Búsqueda de cliente por nombre'"
          :clean-on="false"
          :placeh="tp_check.clientName"
          :externalsrc="'/api/clients/getClients'"
          limit-chars="1"
          v-on:choosed="clientUpdate"
          v-on:empty="clientEmpty"
        />
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-monto">Monto</label>
        <input
          id="tpcheck-monto"
          v-model="tp_check.amount"
          type="number"
          step="0.01"
          class="form-control"
          placeholder="Monto"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-fecha-emision">Fecha de emisión</label>
        <input
          id="tpcheck-fecha-emision"
          v-model="tp_check.date_issue"
          type="date"
          class="form-control"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-fecha-cobro">Fecha de cobro</label>
        <input
          id="tpcheck-fecha-cobro"
          v-model="tp_check.date_due"
          type="date"
          class="form-control"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="tpcheck-notas">Notas</label>
        <textarea
          id="tpcheck-notas"
          v-model="tp_check.note"
          class="form-control"
          placeholder="Notas..."
          rows="2"
        />
      </div>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn form-card__btn--primary" @click="saveTpCheck">
        <i class="bi bi-check-lg"></i>
        Guardar cheque
      </button>
    </div>
  </div>
</template>

<script>
import formatDateMixin from "../../mixins/formatDateMixin";
import SucursalesBancarias from "./../sub-components/sucursalesBancarias.vue";
import typeahead from '../global/Typeahead.vue';
import { CHECK_KIND_OPTIONS } from "../../constants/checkKind";

export default {
  components: {
    SucursalesBancarias,
    typeahead,
  },
  mixins: [formatDateMixin],
  props: ["tpcheckId", "showNewBtn"],
  data() {
    return {
      modo: "nuevo",
      checkKindOptions: CHECK_KIND_OPTIONS,
      tp_check: {
        number: null,
        name: "",
        cuit: null,
        bank_name: "",
        date_issue: "",
        date_due: "",
        client_id: null,
        clientName: null,
        amount: null,
        note: "",
        check_kind: 'fisico',
      },
      emptyTp_check: {
        number: null,
        name: "",
        cuit: null,
        bank_name: "",
        date_issue: "",
        date_due: "",
        client_id: null,
        clientName: '',
        amount: null,
        note: "",
        check_kind: 'fisico',
      },
    };
  },
  watch: {
    tpcheckId(value) {
      if (value != null) {
        this.getTpcheck(value);
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.resetForm();
    if (this.tpcheckId != null) {
      this.getTpcheck(this.tpcheckId);
    }
  },
  methods: {
    validateForm() {
      if (this.tp_check.number === null || isNaN(this.tp_check.number)) {
        alert("Debe ingresar un número de cheque");
        return false;
      }
      if (this.tp_check.name === null || this.tp_check.name === "") {
        alert("Debe ingresar un nombre");
        return false;
      }
      if (this.tp_check.cuit === null || isNaN(this.tp_check.cuit)) {
        alert("Debe ingresar un nro de CUIT");
        return false;
      }
      if (this.tp_check.bank_name == null || this.tp_check.bank_name === "") {
        alert("Debe ingresar el nombre del banco");
        return false;
      }
      if (this.tp_check.date_due == null || this.tp_check.date_due === "") {
        alert("Debe ingresar la fecha de cobro");
        return false;
      }
      if (this.tp_check.date_issue == null || this.tp_check.date_issue === "") {
        alert("Debe ingresar la fecha de emisión");
        return false;
      }
      if (this.tp_check.amount == null || isNaN(this.tp_check.amount)) {
        alert("Ingrese el monto");
        return false;
      }
      return true;
    },
    getTpcheck(id) {
      this.modo = "editar";
      this.$http.get("/api/funds/tp_checks/get/" + id).then((response) => {
        this.tp_check = response.data.data;
        this.tp_check.date_issue = this.formatoFecha2Date(this.tp_check.date_issue);
        this.tp_check.date_due = this.formatoFecha2Date(this.tp_check.date_due);
      });
    },
    saveTpCheck() {
      if (!this.validateForm()) return;
      if (this.tp_check.id != null) {
        const data = {
          ...this.tp_check,
          date_issue: this.formatoDate2Fecha(this.tp_check.date_issue),
          date_due: this.formatoDate2Fecha(this.tp_check.date_due),
        };
        this.$http.post("/api/funds/tp_checks/edit/" + this.tp_check.id, data).then(() => {
          this.resetForm();
          this.$emit("confirmsave");
        });
      } else {
        this.$http.post("/api/funds/tp_checks/add", this.tp_check).then(() => {
          this.resetForm();
          this.$emit("confirmsave");
        });
      }
    },
    clientUpdate(data) {
      this.tp_check.client_id = data.id;
    },
    clientEmpty() {
      this.tp_check.client_id = null;
    },
    resetForm() {
      this.tp_check = Object.assign({}, this.emptyTp_check);
      this.$emit("reset-id");
    },
  },
};
</script>
